<template>
  <div>
    <Snackbar :SnackBarComponent="SnackBarComponent" />
    <v-dialog
      v-model="dialogProfileDetailsPending"
      persistent
      max-width="500px"
      class="mt-n4"
      overlay-color="black"
      :overlay-opacity="0.8"
    >
      <v-card class="CardBorderRadius">
        <v-toolbar dark dense class="elevation-0" color="primary">
          <div>Please Fill Profile Details</div>
        </v-toolbar>
        <v-card-text class="text-center pb-0">
          <v-form ref="form">
            <div align="center">
              <v-col
                cols="6"
                md="6"
                xs="12"
                sm="12"
                class="ma-3 text-center"
                align="center"
                v-if="
                  $store.getters.get_current_user_details.user_image_url ==
                    undefined ||
                  $store.getters.get_current_user_details.user_image_url == null
                "
              >
                <v-card width="100%" class="elevation-0" align="center">
                  <!-- <div class="fontsize12px text-center">Profile Pic *</div> -->
                  <v-card
                    width="100px"
                    height="80px"
                    @click="checkImagePresent()"
                  >
                    <v-fab-transition v-if="imgSrc != ''">
                      <v-btn
                        absolute
                        icon
                        top
                        right
                        dark
                        x-small
                        fab
                        color="red"
                        class="mt-3 mr-n5"
                        @click.stop="(imgSrc = ''), (uploadedImage = false)"
                      >
                        <v-icon>mdi-close-circle</v-icon>
                      </v-btn>
                    </v-fab-transition>
                    <v-img
                      contain
                      v-if="imgSrc && imgSrc != ''"
                      :src="imgSrc"
                      :lazy-src="imgSrc"
                      max-width="100px"
                      height="80px"
                    ></v-img>
                    <div v-else>
                      <input
                        ref="image-upload-input"
                        accept="image/*"
                        capture="user"
                        class="image-upload-input"
                        type="file"
                        @change="handleClick"
                      />
                      <v-icon class="mt-8">mdi-account</v-icon>
                      <div class="fontsize8px">Upload Image</div>
                    </div>
                  </v-card>
                </v-card>
              </v-col>
              <v-text-field
                outlined
                dense
                label="Name *"
                class="borderRadius field_height field_label_size fontsize12px"
                required
                :rules="[(v) => !!v || 'Required']"
                v-model="fillProfileDetailsObject.user_name"
              ></v-text-field>
              <v-row>
                <v-col cols="4" md="3" xs="3" sm="3">
                  <v-select
                    dense
                    outlined
                    :items="CountryCodeItems"
                    v-model="CountryCode"
                    class="field_height"
                  >
                  </v-select>
                </v-col>
                <v-col cols="8" md="9" xs="9" sm="9">
                  <v-text-field
                    outlined
                    dense
                    max-length="10"
                    label="Phone Number *"
                    class="borderRadius field_height field_label_size fontsize12px"
                    required
                    :rules="[
                      (v) => !!v || 'Required',
                      (v) => /^\d+$/.test(v) || 'Must be a number',
                    ]"
                    v-model="fillProfileDetailsObject.user_phone_number"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-text-field
                outlined
                dense
                label="Badge Number *"
                class="borderRadius field_height field_label_size fontsize12px"
                required
                :rules="[
                  (v) => !!v || 'Required',
                  (v) =>
                    /^(?=[a-zA-Z0-9@._%+-]{0,30}$)[0-9]{0,64}$/.test(v) ||
                    'Invalid',
                ]"
                v-model="fillProfileDetailsObject.badge_number"
              ></v-text-field>
              <v-row>
                <v-col cols="6" md="6" xs="6" sm="6">
                  <v-text-field
                    outlined
                    dense
                    label="Station *"
                    class="borderRadius field_height field_label_size fontsize12px"
                    required
                    :rules="[(v) => !!v || 'Required']"
                    v-model="fillProfileDetailsObject.precinct"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="6" xs="6" sm="6">
                  <v-text-field
                    outlined
                    dense
                    label="Station Number *"
                    class="borderRadius field_height field_label_size fontsize12px"
                    required
                    :rules="[
                      (v) => !!v || 'Required',
                      (v) =>
                        /^(?=[a-zA-Z0-9@._%+-]{0,30}$)[0-9]{0,64}$/.test(v) ||
                        'Invalid',
                    ]"
                    v-model="fillProfileDetailsObject.precinct_phone_number"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="mt-n6">
                <v-col cols="9" md="9" xs="9" sm="9">
                  <v-text-field
                    dense
                    outlined
                    label="Zip Code *"
                    class="borderRadius field_height field_label_size fontsize12px"
                    :rules="[(v) => !!v || 'Required']"
                    v-model="fillProfileDetailsObject.zip_code"
                    @keydown.enter="getAddressFromPincode()"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" md="3" xs="3" sm="3">
                  <v-btn
                    color="primary"
                    depressed
                    x-small
                    class="mt-1 ml-n6"
                    @click.stop="getAddressFromPincode()"
                    :loading="zoneloading"
                    >get Location</v-btn
                  >
                </v-col>
              </v-row>
              <v-row class="mt-n5">
                <v-col cols="6" md="6" xs="6" sm="6">
                  <v-text-field
                    dense
                    outlined
                    label="County"
                    class="borderRadius field_height field_label_size fontsize12px"
                    v-model="fillProfileDetailsObject.police_county"
                    :rules="[(v) => !!v || 'Required']"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="6" xs="6" sm="6">
                  <v-text-field
                    dense
                    outlined
                    label="City"
                    class="borderRadius field_height field_label_size fontsize12px"
                    v-model="fillProfileDetailsObject.police_city"
                    :rules="[(v) => !!v || 'Required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-text-field
                dense
                outlined
                label="State"
                class="borderRadius field_height field_label_size fontsize12px"
                v-model="fillProfileDetailsObject.police_state"
                :rules="[(v) => !!v || 'Required']"
              ></v-text-field>
              <v-autocomplete
                dense
                outlined
                label="Zone"
                class="borderRadius field_height field_label_size fontsize12px"
                :items="
                  Array.from(Array(6).keys()).map((i) => 'Zone' + (i + 1))
                "
                v-model="fillProfileDetailsObject.police_zone"
                :rules="[(v) => !!v || 'Required']"
              ></v-autocomplete>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn
            small
            class="borderRadius text-capitalize"
            color="primary"
            outlined
            @click="$router.push('/')"
            ><v-icon small class="mr-1">mdi-exit-to-app</v-icon>Logout</v-btn
          >
          <v-btn
            small
            class="borderRadius text-capitalize mr-2"
            color="primary"
            :loading="loading"
            @click="validateMethod()"
            ><v-icon small class="mr-1">mdi-check</v-icon>Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Snackbar from "@/components/Extras/Snackbar.vue";

import { updateProfileDetails } from "@/mixins/Methods/updateProfileDetails.js";
import { GenerateUploadURL } from "@/mixins/UploadImageURL.js";
export default {
  props: {
    dialogProfileDetailsPending: Boolean,
    getCurrentUserDetailsObject: Object,
    StoreObj: Object,
  },
  components: {
    Snackbar,
  },
  mixins: [updateProfileDetails, GenerateUploadURL],
  data: () => ({
    Toggle: 0,

    loading: false,
    SnackBarComponent: {},
    CountryCodeItems: ["+1", "+91"],
    CountryCode: "+1",
    fillProfileDetailsObject: {
      user_image_url: "",
      user_name: "",
      badge_number: "",
      precinct: "",
      precinct_phone_number: "",
      user_phone_number: "",
      zip_code: "",
      police_county: "",
      police_state: "",
      police_city: "",
      police_zone: "",
    },
    imgSrc: "",
    uploadedImage: false,
    zoneloading: false,
  }),
  watch: {
    dialogProfileDetailsPending(value) {
      if (value) {
        this.fillProfileDetailsObject.user_id =
          this.$store.getters.get_current_user_details.user_id;
        this.fillProfileDetailsObject.user_name =
          this.getCurrentUserDetailsObject.user_name;

        if (
          this.$store.getters.get_current_user_details.user_status == "ACTIVE"
        ) {
          this.fillProfileDetailsObject.user_name =
            this.getCurrentUserDetailsObject.user_name;
          this.fillProfileDetailsObject.badge_number =
            this.getCurrentUserDetailsObject.badge_number;
          this.fillProfileDetailsObject.precinct_phone_number =
            this.getCurrentUserDetailsObject.precinct_phone_number;
          this.fillProfileDetailsObject.user_phone_number =
            this.getCurrentUserDetailsObject.user_phone_number;
          this.fillProfileDetailsObject.precinct =
            this.getCurrentUserDetailsObject.precinct;
        }
      }
    },
  },
  mounted() {},
  methods: {
    async validateMethod() {
      if (
        this.$store.getters.get_current_user_details.user_image_url == undefined
      ) {
        if (this.$refs.form.validate() && this.imgSrc != "") {
          if (
            this.$store.getters.get_current_user_details.user_image_url ==
            undefined
          ) {
            this.fillProfileDetailsObject.user_image_url = this.imgSrc;
          }
          this.fillProfileDetailsObject.user_phone_number =
            this.CountryCode.concat(
              this.fillProfileDetailsObject.user_phone_number
            );
          let result = await this.updateProfileDetailsMethod(
            this.fillProfileDetailsObject
          );
          if (result == "SUCCESS") {
            this.dialogProfileDetailsPendingEmit(2);
          }
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Image and Fields Marked With * Are Mandatory !!",
          };
        }
      } else {
        if (this.$refs.form.validate()) {
          // if (
          //   this.$store.getters.get_current_user_details.user_image_url ==
          //   undefined
          // ) {
          //   this.fillProfileDetailsObject.user_image_url =
          //     this.imgSrc == "" || this.imgSrc == undefined
          //       ? undefined
          //       : this.imgSrc;
          // }
          this.fillProfileDetailsObject.user_image_url = undefined;
          this.fillProfileDetailsObject.user_phone_number =
            this.CountryCode.concat(
              this.fillProfileDetailsObject.user_phone_number
            );
          let result = await this.updateProfileDetailsMethod(
            this.fillProfileDetailsObject
          );
          if (result == "SUCCESS") {
            this.dialogProfileDetailsPendingEmit(2);
          }
        } else {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "red",
            Top: true,
            SnackbarText: "Fields Marked With * Are Mandatory !!",
          };
        }
      }
    },
    dialogProfileDetailsPendingEmit(Toggle) {
      this.$emit("clicked", Toggle);
    },
    checkImagePresent() {
      if (this.imgSrc || this.imgSrc == "") {
        this.$refs["image-upload-input"].click();
      }
    },
    handleClick(e) {
      this.Uploading = true;
      const key = `${e.target.files[0].name}`;
      this.selectedFiles = e.target.files[0];
      this.GenerateUploadURLMethods(key, this.selectedFiles);
    },
    async getAddressFromPincode() {
      this.zoneloading = true;
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?postalcode=${this.fillProfileDetailsObject.zip_code}&format=json&addressdetails=1`
      );
      const data = await response.json();
      console.log("datttta", data);

      if (data && data.length) {
        const address = data[0].address;

        const city = address.city || address.town || address.state_district;
        const state = address.state;
        const county = address.county;

        this.fillProfileDetailsObject.police_county = county;
        this.fillProfileDetailsObject.police_state = state;
        this.fillProfileDetailsObject.police_city = city;
        this.zoneloading = false;
      }
      this.zoneloading = false;
      return {
        city: "City not found",
        state: "State not found",
        country: "Country not found",
      };
    },
  },
};
</script>
